import { DataGrid } from "@mui/x-data-grid";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Input, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { getVendors } from "../../../services/vendorService";
import { debounce } from "@mui/material";
const VendorPopup = ({
  isVendorPopupOpen,
  setIsVendorPopupOpen,
  handleVendorAssignment,
}) => {
  const colDefs = [
    {
      field: "name",
      headerName: "Name",
      flex: 2,
    },
    {
      field: "vendorTierDesc",
      headerName: "Tier",
      flex: 1,
    },
    // {
    //   field: "vendorSubmissionStatus",
    //   headerName: "Submission Status",
    //   flex: 2,
    // },
  ];

  const [nameFilter, setNameFilter] = useState("");

  const getVendorsList = async (nameFilter) => {
    const data = await getVendors(nameFilter, null, null, null);
    setVendorList(data ?? []);
  };

  const [vendorList, setVendorList] = useState([]);

  useEffect(() => {
    processDebounce(nameFilter);
  }, [nameFilter]);

  const processDebounce = useCallback(
    debounce((nameFilter) => getVendorsList(nameFilter), 400),
    []
  );

  useEffect(() => {
    if (isVendorPopupOpen) getVendorsList();
  }, [isVendorPopupOpen]);

  return (
    <>
      <Modal
        size="md"
        isOpen={isVendorPopupOpen}
        toggle={() => setIsVendorPopupOpen(false)}
      >
        <ModalHeader toggle={() => setIsVendorPopupOpen(false)}>
          {"Assign Vendor"}
        </ModalHeader>
        <ModalBody>
          <Row className="mb-3">
            <Col md={12}>
              <Input
                type="text"
                name="name"
                autocomplete="off"
                value={nameFilter}
                onChange={(e) => {
                  setNameFilter(e.target.value);
                }}
                id="name"
                placeholder="Search with Name"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="assessor-popup-list-grid-container">
                <DataGrid
                  sx={{
                    // disable cell selection style
                    ".MuiDataGrid-cell:focus": {
                      outline: "none",
                    },
                    // pointer cursor on ALL rows
                    "& .MuiDataGrid-row:not(.disabled-row):hover": {
                      cursor: "pointer",
                    },
                  }}
                  rows={vendorList}
                  columns={colDefs}
                  hideFooter
                  onRowSelectionModelChange={async (newRowSelectionModel) => {
                    if (newRowSelectionModel.length === 0) return;
                    handleVendorAssignment(
                      vendorList.filter(
                        (x) => x.id === newRowSelectionModel[0]
                      )[0]
                    );
                    setIsVendorPopupOpen(false);
                  }}
                  density="compact"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default VendorPopup;
